(() => {
  'use strict';
  const source = document.currentScript;
  const project = source?.dataset.vodClarityProject;
  if (project !== 'yy4n9c8xfm' || window.__vodClarityConsent) return;
  window.__vodClarityConsent = true;
  const state = (value) => { document.documentElement.dataset.vodClarity = value; };
  const privatePath = /\/(account|accounts|checkout|checkouts|orders|order-status|cart|search|apps|password|challenge|authentication)(\/|$)|contact|custom-invoice|commission/i;
  const safeQuery = (url) => [...url.searchParams].every(([key, value]) => {
    if (['variant', 'page', 'preview_theme_id'].includes(key)) return /^\d{1,20}$/.test(value);
    if (key === 'sort_by') return /^(manual|best-selling|title-ascending|title-descending|price-ascending|price-descending|created-ascending|created-descending)$/.test(value);
    return false;
  });
  const safeLocation = () => {
    try {
      const url = new URL(window.location.href);
      if (!['viultofdelights.com', 'www.viultofdelights.com'].includes(url.hostname)) return false;
      if (privatePath.test(decodeURIComponent(url.pathname)) || url.hash || !safeQuery(url)) return false;
      if (document.referrer) {
        const previous = new URL(document.referrer);
        if (privatePath.test(decodeURIComponent(previous.pathname)) || previous.hash || !safeQuery(previous)) return false;
      }
      return !window.Shopify?.designMode && navigator.globalPrivacyControl !== true;
    } catch { return false; }
  };
  if (!safeLocation()) { state('excluded'); return; }
  let started = false;
  let revoked = false;
  let tracker;
  const hasConsent = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent().analytics === 'yes'
        && privacy.analyticsProcessingAllowed() === true
        && safeLocation();
    } catch { return false; }
  };
  const stop = () => {
    if (!started || revoked) return;
    revoked = true;
    window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
    window.clarity('stop');
    tracker?.remove();
    state('stopped');
  };
  const sync = () => {
    if (!hasConsent()) { if (started) stop(); else state('awaiting-consent'); return; }
    if (started || revoked) return;
    if (window.clarity || document.querySelector('script[src*="clarity.ms/tag/"]')) {
      state('duplicate-installation-blocked');
      return;
    }
    document.documentElement.setAttribute('data-clarity-mask', 'true');
    window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
    started = true;
    tracker = document.createElement('script');
    tracker.async = true;
    tracker.src = 'https://www.clarity.ms/tag/' + project;
    tracker.referrerPolicy = 'strict-origin';
    tracker.dataset.vodClarityTracker = 'true';
    tracker.onload = () => {
      if (revoked || !hasConsent()) {
        window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
        window.clarity('stop');
        state('stopped');
      } else state('loaded-with-consent');
    };
    tracker.onerror = () => { state('load-failed'); };
    state('loading-with-consent');
    document.head.appendChild(tracker);
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pagehide', stop);
  window.addEventListener('popstate', () => { if (!safeLocation()) stop(); });
  window.addEventListener('hashchange', () => { if (!safeLocation()) stop(); });
  state('awaiting-consent');
  if (window.Shopify?.customerPrivacy) sync();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) sync();
      else state('privacy-api-unavailable');
    });
  } else state('privacy-api-unavailable');
})();
